// riskHelpIds.js
export const riskHelpIds = {
  IMPACT: 1,
  PROBABILITY: 2,
  RISKLEVEL: 3,
  CONTROLTYPE: 4,
  FREQUENCY: 5,
  CONTROLEFFECTIVENESS: 6,
  RESIDUALRISK: 7,
  RISKTYPE: 8,
  RISKSTATE: 9,
  VULNERABILITY: 10,
};

export const riskHelpConfig = {
  [riskHelpIds.IMPACT]: {
    title: "Impacto",
    columns: [
      { field: "name", header: "Impacto" },
      { field: "description", header: "Descripción", columnType: "fullText" },
      { field: "valor", header: "Valoración", columnType: "fullText" }
    ],
    data: [
      {
        name: "Insignificante",
        description: "Afecta entre 0% y 5% los resultados del proceso.",
        valor: 1
      },
      {
        name: "Menor",
        description: "Afecta entre 5,1% y 10% los resultados del proceso.",
        valor: 2
      },
      {
        name: "Moderado",
        description: "Afecta entre 10,1% y 25% los resultados del proceso.",
        valor: 3
      },
      {
        name: "Mayor",
        description: "Afecta entre 25,1% y 80% los resultados del proceso.",
        valor: 4
      },
      {
        name: "Enorme",
        description: "Afecta entre 80,1% y 100% los resultados del proceso.",
        valor: 5
      }
    ]
  },
  [riskHelpIds.PROBABILITY]: {
    title: "Probabilidad",
    columns: [
      { field: "name", header: "Probabilidad" },
      { field: "description", header: "Descripción", columnType: "fullText" },
      { field: "valor", header: "Valoración", columnType: "fullText" }
    ],
    data: [
      {
        name: "Raro",
        description: "Existe entre el 0% y 5% de probabilidad que ocurra.",
        valor: 1
      },
      {
        name: "Improbable",
        description: "Existe entre el 5,1% y 10% de probabilidad que ocurra.",
        valor: 2
      },
      {
        name: "Posible",
        description: "Existe entre el 10,1% y 25% de probabilidad que ocurra.",
        valor: 3
      },
      {
        name: "Probable",
        description: "Existe entre el 25,1% y 80% de probabilidad que ocurra.",
        valor: 4
      },
      {
        name: "Casi seguro",
        description: "Existe entre el 80,1% y 100% de probabilidad que ocurra.",
        valor: 5
      }
    ]
  },
  [riskHelpIds.VULNERABILITY]: {
    title: "Criterios de vulnerabilidad",
    columns: [
      { field: "name", header: "Criterio" },
      { field: "descriptionRiesgo", header: "En caso de ser un riesgo", columnType: "fullText" },
      { field: "descriptionOportunidad", header: "En caso de ser una oportunidad", columnType: "fullText" },
      { field: "valor", header: "Valoración" }
    ],
    data: [
      {
        name: "Baja",
        descriptionRiesgo:
          "Cuenta con todos los medios posibles para garantizar que ante una amenaza el daño sea el menor posible: equipos, capacitaciones, charlas, etc.",
        descriptionOportunidad:
          "Cuenta con pocos o ningún medio para aprovechar el impulso ante una oportunidad.",
        valor: 1
      },
      {
        name: "Media",
        descriptionRiesgo:
          "Cuenta con algunos medios para que ante un riesgo los daños generados sean de medio nivel.",
        descriptionOportunidad:
          "Cuenta con algunos medios para que ante una oportunidad, los beneficios generados sean de medio nivel.",
        valor: 3
      },
      {
        name: "Alta",
        descriptionRiesgo:
          "No cuenta con ningún medio para mitigar el daño ante un riesgo.",
        descriptionOportunidad:
          "Cuenta con muchos medios para aprovechar el impulso ante una oportunidad.",
        valor: 5
      }
    ]
  },
  [riskHelpIds.RISKLEVEL]: {
    title: "Nivel de Riesgo",
    columns: [
      { field: "name", header: "Calificación" },
      { field: "valor", header: "Rango (Código)" },
      { field: "posiblesTratamientos", header: "Posibles tratamientos", columnType: "fullText" }
    ],
    data: [
      {
        name: "Riesgo Bajo",
        valor: "1 a 10 (RB)",
        posiblesTratamientos: "Asumir el riesgo para perseguir una oportunidad."
      },
      {
        name: "Riesgo Medio",
        valor: "11 a 25 (RM)",
        posiblesTratamientos: "Mantener el riesgo mediante decisiones informadas."
      },
      {
        name: "Riesgo Alto",
        valor: "26 a 50 (RA)",
        posiblesTratamientos: "Evitar el riesgo."
      },
      {
        name: "Riesgo Superior",
        valor: "51 a 125 (RS)",
        posiblesTratamientos: "Cambiar la probabilidad o las consecuencias. Eliminar la fuente del riesgo. Compartir o transferir el riesgo."
      }
    ]
  },
  [riskHelpIds.CONTROLTYPE]: {
    title: "Tipo de Control",
    columns: [
      { field: "name", header: "Tipo de Control" },
      { field: "description", header: "Definición", columnType: "fullText" },
      { field: "valor", header: "Valoración" }
    ],
    data: [
      {
        name: "Preventivo",
        description: "Sí el control se aplica antes o al iniciar un proceso",
        valor: 4
      },
      {
        name: "Correctivo",
        description:
          "Sí el control se aplica durante el proceso y permite corregir las deficiencias que se encuentran",
        valor: 3
      },
      {
        name: "Detectivo",
        description: "Sí el control se aplica cuando el proceso ha terminado",
        valor: 2
      },
      {
        name: "Inexistente",
        description: "No existe ninguna medida de control.",
        valor: 1
      }
    ]
  },
  [riskHelpIds.FREQUENCY]: {
    title: "Frecuencia del Control",
    columns: [
      { field: "name", header: "Frecuencia" },
      { field: "description", header: "Definición", columnType: "fullText" },
      { field: "valor", header: "Valoración" }
    ],
    data: [
      {
        name: "Permanente",
        description:
          "El control se realiza durante todo el proceso, es decir, en cada actividad",
        valor: 3
      },
      {
        name: "Periódico",
        description:
          "El control se realiza transcurridas un número de actividades o un tiempo determinado",
        valor: 2
      },
      {
        name: "Ocasional",
        description:
          "El control se realiza solo en forma ocasional en un proceso",
        valor: 1
      }
    ]
  },
  [riskHelpIds.CONTROLEFFECTIVENESS]: {
    title: "Eficacia de control",
    columns: [
      { field: "effect", header: "Efectividad" },
      { field: "valor", header: "Valoración" }
    ],
    data: [
      { effect: "Inexistente", valor: 1 },
      { effect: "Baja", valor: "2 - 4" },
      { effect: "Media", valor: "5 - 8" },
      { effect: "Alta", valor: "9 - 12" }
    ]
  },
  [riskHelpIds.RESIDUALRISK]: {
    title: "Nivel del Riesgo Residual",
    columns: [
      { field: "name", header: "Nivel" },
      { field: "description", header: "Definición", columnType: "fullText" },
      { field: "valor", header: "Valoración", columnType: "fullText" }
    ],
    data: [
      {
        name: "Tolerable",
        description:
          "Nivel de riesgo que, aunque existe, no representa una amenaza significativa para los objetivos de la organización.",
        valor: "< 5"
      },
      {
        name: "Moderado",
        description:
          "Riesgo con probabilidad e impacto medio, controlable dentro de la operación normal.",
        valor: "5 - 7"
      },
      {
        name: "Importante",
        description:
          "Riesgo con un nivel de impacto o probabilidad relevante, que debe ser gestionado porque puede afectar procesos, recursos o la satisfacción de las partes interesadas.",
        valor: "8 - 11"
      },
      {
        name: "Inaceptable",
        description:
          "Riesgo con un nivel crítico de impacto o alta probabilidad, que amenaza la seguridad, la continuidad del negocio o el cumplimiento legal.",
        valor: "≥ 12"
      }
    ]
  },
  [riskHelpIds.RISKTYPE]: {
    title: "Nivel del Riesgo Residual",
    columns: [
      { field: "name", header: "Nivel" },
      { field: "description", header: "Definición", columnType: "fullText" }
    ],
    data: [
      {
        name: "Evitar",
        description:
          "Se modifica el plan o proceso para eliminar la causa del riesgo."
      },
      {
        name: "Prevenir",
        description:
          "Se busca evitar que el riesgo ocurra o reducir significativamente su probabilidad de ocurrencia."
      },
      {
        name: "Reducir o mitigar",
        description:
          "Se implementan controles para disminuir la probabilidad o el impacto."
      },
      {
        name: "Aceptar y asumir",
        description:
          "Se decide no tomar ninguna acción porque el riesgo es bajo o inevitable. (acá se debe dejar un solo concepto para asumir y aceptar)"
      },
      {
        name: "Retener",
        description:
          "Se decide aceptar el riesgo y asumir sus posibles consecuencias, sin transferirlo ni eliminarlo, pero estableciendo medidas para controlar o mitigar su impacto si llega a ocurrir."
      },
      {
        name: "Transferir",
        description:
          "Se delega el riesgo a un tercero, como un seguro o proveedor."
      }
    ]
  },
  [riskHelpIds.RISKSTATE]: {
    title: "Nivel del Riesgo Residual",
    columns: [
      { field: "name", header: "Nivel" },
      { field: "description", header: "Definición", columnType: "fullText" }
    ],
    data: [
      {
        name: "Materializado",
        description:
          "El riesgo se ha convertido en un evento real. Ya ocurrió y está generando consecuencias negativas. Requiere análisis y acciones correctivas."
      },
      {
        name: "Cerrado sin mitigación",
        description:
          "El riesgo fue eliminado o dejó de ser relevante sin necesidad de aplicar acciones de mitigación. Puede deberse a cambios en el contexto, procesos o decisiones estratégicas."
      },
      {
        name: "Aceptado",
        description:
          "El riesgo se reconoce y se decide no tomar acciones específicas para mitigarlo, ya sea porque su impacto es bajo o el costo de mitigación es mayor que el beneficio."
      },
      {
        name: "Mitigado",
        description:
          "Se han implementado acciones que reducen la probabilidad o el impacto del riesgo a niveles aceptables. El riesgo sigue existiendo, pero está bajo control."
      },
      {
        name: "Mejorado",
        description:
          "El riesgo se ha transformado en una oportunidad o ha generado un aprendizaje que mejora procesos, productos o servicios. Va más allá de la mitigación."
      },
      {
        name: "Latente",
        description:
          "El riesgo está presente, pero no se ha manifestado ni ha sido tratado aún. Puede estar en observación o pendiente de evaluación."
      }
    ]
  }
};
